const ParticipantStatus = {
    OK: 'OK',
    PAYMENT_ERROR: 'PAYMENT_ERROR'
};

export default ParticipantStatus;



// WEBPACK FOOTER //
// src/domain/ParticipantStatus.js